import Navbar from '@/components/Main/Navbar/Navbar.vue'
import AdMenu from '@/components/Main/AdMenu/AdMenu.vue'
import BlogHeader from '@/components/Main/Blog/BlogHeader.vue'
import BlogCard from '@/components/Main/Blog/BlogCard.vue'
import CircleService from '@/services/circle'

const circleService = new CircleService();
const LIMIT = 4;

export default {
  name: 'Blog',
  components: {
    Navbar,
    AdMenu,
    BlogHeader,
    BlogCard
  },
  data() {
    return {
      blog: null,
      articles: null,
      altHeaderText: null,
      page: 1
    }
  },
  created() {
    circleService.getBlog(LIMIT, this.page).then(data => {
      if (data.circle && data.topics) {
        this.blog = data.circle;
        const topics = data.topics.data;

        if (topics.length === LIMIT) {
          this.page += 1
        }

        this.articles = [...(this.articles || []), ...topics];
      } else {
        this.altHeaderText = 'Blog is not available at this time';
        this.articles = [];
      }
    }).catch(err => {
      (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
      (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
    })
  },
  methods: {
    loadMore(e) {
      const btn = e.srcElement;

      btn.disabled = true;
      btn.innerText = 'Loading'
      btn.classList.add('btn--loading');

      circleService.getBlog(LIMIT, this.page).then(data => {
        this.blog = data.circle;
        const topics = data.topics.data;
  
        if (topics.length === LIMIT) {
          this.page += 1
        }

        const allArticles = [...(this.articles || []), ...topics];

        this.articles = Array.from(new Set(allArticles.map(s => s._id))).map(s => allArticles.find(a => a._id === s));

        btn.disabled = false;
        btn.innerText = 'Load more'
        btn.classList.remove('btn--loading');
      }).catch(err => {
        btn.disabled = false;
        btn.innerText = 'Load more'
        btn.classList.remove('btn--loading');

        (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) : 
        (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      })
    },
    has(obj, path) {
      if (typeof path !== "string") {
        return false;
      }
      var path_array = path.split(".");
      if (obj.hasOwnProperty(path_array[0])) {
        if (path_array.length > 1) {
          var newPath = path_array
            .slice(1)
            .join(".")
            .toString();
          return has(obj[path_array[0]], newPath);
        }
        return obj.hasOwnProperty(path_array[0]);
      }
      return false;
    }
  }
}
